import React from "react";
import "./homeLoading.css";
import aapmorLogo from "../../src/assets/AAPMOR LOGO.svg";
const HomeLoading = (props) => {
  return (
    <img
      style={{ width: "10%" }}
      src={aapmorLogo}
      alt="aapmor-logo-animated"
      className="blink"
    />
  );
};

export default HomeLoading;
